import { Button, ButtonProps } from "@mui/material";
import { useDialogProviderContext } from "..";

const Toggle = (props: ButtonProps) => {
  const { setIsOpen } = useDialogProviderContext();
  return (
    <Button
      color="secondary"
      variant="contained"
      onClick={() => setIsOpen(true)}
      {...props}
    />
  );
};

export default Toggle;
